import { StateToken } from '@ngxs/store';
import { RoomTranscriptionRow } from '../../../shared/services/transcriber.service';
import { IARTSuggestion, JoinEvent, LiveRecruterScoresData, LLNote } from './meetcall.types';

export interface MeetCallStateModel {
  roomTranscription: RoomTranscriptionRow[];
  joinData: JoinEvent | null;
  candidatScores: LiveRecruterScoresData[];
  suggestion: IARTSuggestion | null;
  comments: LLNote[];
  linkData: string;
}
export const MEETCALL_STATE_TOKEN = new StateToken<MeetCallStateModel>('meetcallState');

export const INITIAL_MEETCALL_STATE: MeetCallStateModel = {
  roomTranscription: [],
  joinData: null,
  candidatScores: [],
  suggestion: null,
  comments: [],
  linkData: '',
};
